/* tslint:disable */
/* eslint-disable */
export enum CampaignTypeEnum {
  NotSet = 0,
  Standard = 1,
  Impact = 2,
  Plugg = 3
}
